(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands_slider"] && !Shopify.designMode) return;
  try {
    

// form a brands slider with slick
  $('.brands-responsive').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 4,
 	arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-child-grid"] && !Shopify.designMode) return;
  try {
    
    (function () {
      // Drastically simplified JavaScript! 
      // CSS now handles hiding things instantly, JS just toggles the ".is-expanded" class.
      function isSizeParamKey(key) {
        if (!key) return false;

        var normalized = String(key).toLowerCase();
        if (normalized === 'page_size') return false;
        if (normalized.indexOf('size') === -1) return false;
        if (normalized.indexOf('resize') !== -1) return false;
        return true;
      }

      function getCurrentSizeParams() {
        var currentSizeParams = [];
        if (!window.URLSearchParams || !window.location) return currentSizeParams;

        function pushUniqueParam(key, value) {
          for (var i = 0; i < currentSizeParams.length; i += 1) {
            if (currentSizeParams[i].key === key && currentSizeParams[i].value === value) {
              return;
            }
          }

          currentSizeParams.push({ key: key, value: value });
        }

        var currentParams = new URLSearchParams(window.location.search || '');
        currentParams.forEach(function (value, key) {
          if (isSizeParamKey(key)) {
            pushUniqueParam(key, value);
          }
        });

        var filterInputs = document.querySelectorAll('input[name], select[name]');
        for (var inputIndex = 0; inputIndex < filterInputs.length; inputIndex += 1) {
          var input = filterInputs[inputIndex];
          if (!input) continue;

          var inputName = input.name || '';
          if (!isSizeParamKey(inputName)) continue;

          var tagName = (input.tagName || '').toLowerCase();
          if (tagName === 'input') {
            var type = (input.type || '').toLowerCase();
            if (type !== 'checkbox' && type !== 'radio') continue;
            if (!input.checked) continue;
            pushUniqueParam(inputName, input.value);
            continue;
          }

          if (tagName === 'select') {
            if (input.multiple && input.options) {
              for (var optionIndex = 0; optionIndex < input.options.length; optionIndex += 1) {
                var option = input.options[optionIndex];
                if (option && option.selected && option.value !== '') {
                  pushUniqueParam(inputName, option.value);
                }
              }
            } else {
              if (input.value !== '') {
                pushUniqueParam(inputName, input.value);
              }
            }
          }
        }

        return currentSizeParams;
      }

      function removeSizeParamsFromUrl(linkUrl) {
        var keysToDelete = [];
        linkUrl.searchParams.forEach(function (_, key) {
          if (isSizeParamKey(key) && keysToDelete.indexOf(key) === -1) {
            keysToDelete.push(key);
          }
        });

        for (var keyIndex = 0; keyIndex < keysToDelete.length; keyIndex += 1) {
          linkUrl.searchParams.delete(keysToDelete[keyIndex]);
        }
      }

      function toRelativeHref(urlObject) {
        return urlObject.pathname + urlObject.search + urlObject.hash;
      }

      function initializeChildLinkBaseHref(link) {
        if (!link) return;
        if (link.getAttribute('data-child-grid-base-href')) return;

        var href = link.getAttribute('href');
        if (!href) return;
        if (href.indexOf('javascript:') === 0 || href.charAt(0) === '#') return;

        var linkUrl;
        try {
          linkUrl = new URL(href, window.location.origin);
        } catch (error) {
          return;
        }

        removeSizeParamsFromUrl(linkUrl);
        link.setAttribute('data-child-grid-base-href', toRelativeHref(linkUrl));
      }

      function applyCurrentSizeParamsToLink(link) {
        if (!link) return;

        var baseHref = link.getAttribute('data-child-grid-base-href');
        var href = baseHref || link.getAttribute('href');
        if (!href) return;
        if (href.indexOf('javascript:') === 0 || href.charAt(0) === '#') return;

        var linkUrl;
        try {
          linkUrl = new URL(href, window.location.origin);
        } catch (error) {
          return;
        }

        removeSizeParamsFromUrl(linkUrl);

        var currentSizeParams = getCurrentSizeParams();
        for (var sizeIndex = 0; sizeIndex < currentSizeParams.length; sizeIndex += 1) {
          linkUrl.searchParams.append(currentSizeParams[sizeIndex].key, currentSizeParams[sizeIndex].value);
        }

        link.setAttribute('href', toRelativeHref(linkUrl));
      }

      function persistSizesParamsOnChildLinks(section) {
        if (!section) return;
        if (!window.URLSearchParams || !window.URL) return;

        var links = section.querySelectorAll('[data-child-grid-card]');
        for (var linkIndex = 0; linkIndex < links.length; linkIndex += 1) {
          var link = links[linkIndex];
          initializeChildLinkBaseHref(link);
          applyCurrentSizeParamsToLink(link);

          if (link.getAttribute('data-child-grid-size-listener') !== 'true') {
            link.addEventListener('click', function (event) {
              applyCurrentSizeParamsToLink(event.currentTarget);
            });
            link.setAttribute('data-child-grid-size-listener', 'true');
          }
        }
      }

      function syncCollectionChildGridLinks(root) {
        var context = root || document;
        var sections = context.querySelectorAll('[data-child-grid-section]');

        for (var sectionIndex = 0; sectionIndex < sections.length; sectionIndex += 1) {
          persistSizesParamsOnChildLinks(sections[sectionIndex]);
        }
      }

      function bindCollectionChildGridSizeSyncListeners() {
        if (window.__collectionChildGridSizeSyncBound) return;
        window.__collectionChildGridSizeSyncBound = true;

        function scheduleSync() {
          window.setTimeout(function () {
            syncCollectionChildGridLinks(document);
          }, 0);
        }

        function wrapHistoryMethod(methodName) {
          if (!window.history || typeof window.history[methodName] !== 'function') return;

          var originalMethod = window.history[methodName];
          if (originalMethod.__collectionChildGridWrapped) return;

          var wrappedMethod = function () {
            var result = originalMethod.apply(window.history, arguments);
            scheduleSync();
            return result;
          };

          wrappedMethod.__collectionChildGridWrapped = true;
          window.history[methodName] = wrappedMethod;
        }

        wrapHistoryMethod('pushState');
        wrapHistoryMethod('replaceState');

        window.addEventListener('popstate', scheduleSync);
        window.addEventListener('hashchange', scheduleSync);

        document.addEventListener(
          'change',
          function (event) {
            var target = event.target;
            if (!target) return;

            var targetName = target.name || '';
            var targetId = target.id || '';
            if (isSizeParamKey(targetName) || isSizeParamKey(targetId)) {
              scheduleSync();
              window.setTimeout(scheduleSync, 150);
            }
          },
          true
        );
      }

      function initChildGridSection(section) {
        if (!section || section.dataset.childGridReady == 'true') return;

        persistSizesParamsOnChildLinks(section);
  
        var cardsContainer = section.querySelector('[data-child-grid-cards]');
        var button = section.querySelector('[data-child-grid-load-more]');
  
        if (!cardsContainer || !button) {
          if (section) section.dataset.childGridReady = 'true';
          return;
        }
  
        var isExpanded = false;
        var showText = button.textContent.trim();
        var hideText = button.getAttribute('data-hide-text') || 'Hide';
  
        button.addEventListener('click', function () {
          isExpanded = !isExpanded;
          
          if (isExpanded) {
            cardsContainer.classList.add('is-expanded');
            button.textContent = hideText;
          } else {
            cardsContainer.classList.remove('is-expanded');
            button.textContent = showText;
            section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
  
        section.dataset.childGridReady = 'true';
      }
  
      function initCollectionChildGrids(root) {
        var context = root || document;
        var sections = context.querySelectorAll('[data-child-grid-section]');
        
        for (var index = 0; index < sections.length; index += 1) {
          initChildGridSection(sections[index]);
        }

        syncCollectionChildGridLinks(context);
      }
  
      if (document.readyState == 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          initCollectionChildGrids(document);
        });
      } else {
        initCollectionChildGrids(document);
      }
  
      if (!window.__collectionChildGridSectionLoadBound) {
        window.__collectionChildGridSectionLoadBound = true;
        document.addEventListener('shopify:section:load', function (event) {
          initCollectionChildGrids(event.target);
        });
      }

      bindCollectionChildGridSizeSyncListeners();
    })();
  
  } catch(e) { console.error(e); }
})();
})();
